import { default as DustinLogo } from './dustin-logo'

export default DustinLogo
